import Step from '@zenbusiness/zui/Step';
import Stepper from '@zenbusiness/zui/Stepper';
import { styled } from '@zenbusiness/zui/styles';

export const StepperContainer = styled(Stepper)`
  margin-top: 40px;
  margin-bottom: 26px;
`;
export const StepContainer = styled(Step)`
  .MuiSvgIcon-root {
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;
